import { Link } from "@tanstack/react-router";

type Props = {
  brand: string;
  brandClassName?: string;
  tagline: string;
  bullets: string[];
  href: string;
  cta: string;
};

export function ToolCard({ brand, brandClassName, tagline, bullets, href, cta }: Props) {
  return (
    <Link
      to={href}
      className="group flex h-full flex-col gap-5 rounded-lg border border-rule bg-white p-8 transition-all hover:-translate-y-0.5 hover:border-cyan hover:shadow-[0_12px_40px_-20px_oklch(0.6_0.11_225/0.4)]"
    >
      <div className={`font-display text-3xl text-ink ${brandClassName ?? ""}`}>{brand}</div>
      <p className="font-display italic text-lg text-cyan-deep leading-snug">{tagline}</p>
      <ul className="space-y-2 text-sm text-ink-3">
        {bullets.map((b) => (
          <li key={b} className="flex gap-3">
            <span className="text-cyan" aria-hidden>●</span>
            <span>{b}</span>
          </li>
        ))}
      </ul>
      <span className="mt-auto pt-4 font-mono text-xs uppercase tracking-wider text-ink-2 transition-colors group-hover:text-cyan-deep">
        {cta} →
      </span>
    </Link>
  );
}
